import type { Rule } from "antd/es/form";
import type { TFunction } from "i18next";

export const createSmartDetailsFormRules = (t: TFunction) => ({
  transportType: [
    {
      required: true,
      message: t("bookingWizard.transportDetails.transportTypeRequired"),
    },
  ] satisfies Rule[],
  bookingType: [
    {
      required: true,
      message: t("bookingWizard.transportDetails.bookingTypeRequired"),
    },
  ] satisfies Rule[],
  serviceLevel: [
    {
      required: true,
      message: t("bookingWizard.transportDetails.serviceLevelRequired"),
    },
  ] satisfies Rule[],
  bookingIncoterm: [
    {
      required: true,
      message: t("bookingWizard.transportDetails.incotermRequired"),
    },
  ] satisfies Rule[],
  originPickupDate: [
    {
      required: true,
      message: t("bookingWizard.transportDetails.cargoReadinessRequired"),
    },
  ] satisfies Rule[],
  supplierName: [
    {
      required: true,
      message: t("bookingWizard.supplierDetails.supplierNameRequired"),
    },
  ] satisfies Rule[],
  supplierEmail: [
    {
      required: true,
      message: t("bookingWizard.supplierDetails.emailRequired"),
    },
    {
      type: "email" as const,
      message: t("bookingWizard.supplierDetails.validEmail"),
    },
  ] satisfies Rule[],
  supplierPhone: [
    {
      required: true,
      message: t("bookingWizard.supplierDetails.phoneRequired"),
    },
  ] satisfies Rule[],
  supplierCountry: [
    {
      required: true,
      message: t("bookingWizard.supplierDetails.countryRequired"),
    },
  ] satisfies Rule[],
  supplierProvince: [
    {
      required: true,
      message: t("bookingWizard.supplierDetails.provinceRequired"),
    },
  ] satisfies Rule[],
  supplierCity: [
    {
      required: true,
      message: t("bookingWizard.supplierDetails.cityRequired"),
    },
  ] satisfies Rule[],
  supplierAddress: [
    {
      required: true,
      message: t("bookingWizard.supplierDetails.addressRequired"),
    },
  ] satisfies Rule[],
});

/** Extract a usable email from AI / free-text values. */
export const normalizeSupplierEmail = (value: unknown): string => {
  const raw = typeof value === "string" ? value.trim() : "";
  if (!raw) return "";
  const match = raw.match(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/);
  return match ? match[0].toLowerCase() : raw;
};
